import { render } from "./PaginaPrincipal.vue?vue&type=template&id=1277dfc5&scoped=true"
import script from "./PaginaPrincipal.vue?vue&type=script&lang=js"
export * from "./PaginaPrincipal.vue?vue&type=script&lang=js"

import "./PaginaPrincipal.vue?vue&type=style&index=0&id=1277dfc5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1277dfc5"]])

export default __exports__